export default "__VITE_ASSET__B67liDP5__"